/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerStore from 'stores/ActionDrawerStore';
import AccountStore from 'stores/AccountStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  accountStore: AccountStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class ChangeUserRoleSuccess extends ComponentWithInjectedProps<
  {},
  {},
  InjectedProps
> {
  componentDidMount() {
    const { actionDrawerStore, accountStore } = this.props;
    const currentRole = actionDrawerStore.response.current_role;
    const newRole = actionDrawerStore.response.new_role;
    const user = actionDrawerStore.response.user;

    if (!accountStore.specificUser) {
      return;
    }

    if (!user.role_id || (user.role_id && currentRole !== user.role_id)) {
      accountStore.specificUser.role_name = newRole;
      accountStore.specificUser.role_id = user.role_id;
    }
  }

  render() {
    const { t, actionDrawerStore } = this.props;

    // TODO: These need to change when BE sends back role IDs
    const user = actionDrawerStore.response.user;
    const currentRole = actionDrawerStore.response.current_role;
    const newRole = actionDrawerStore.response.new_role;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={
              !user.role_id || (user.role_id && currentRole !== user.role_id)
                ? t('general:users.role_changed')
                : t('general:users.role_change_pending')
            }
          >
            <div className={styles['form-group']}>
              {!user.role_id || (user.role_id && currentRole !== user.role_id)
                ? t('general:users.messages.role_changed')
                : t('general:users.messages.role_change_submitted')}
            </div>
            <div className={styles['disable-account-details']}>
              <ul>
                <li>{`${user.first_name} ${user.last_name}`}</li>
                <br />
                <li>
                  <b>{t('general:roles.labels.current_role')}</b>:<br />{' '}
                  {t(`general:roles.${currentRole}`)}
                </li>
                <br />
                <li>
                  <b>{t('general:roles.labels.new_role')}</b>:<br /> {t(`general:roles.${newRole}`)}
                </li>
              </ul>
            </div>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
